import { render, staticRenderFns } from "./passList.vue?vue&type=template&id=13fb3e7d&scoped=true&"
import script from "./passList.vue?vue&type=script&lang=js&"
export * from "./passList.vue?vue&type=script&lang=js&"
import style0 from "./passList.vue?vue&type=style&index=0&id=13fb3e7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb3e7d",
  null
  
)

export default component.exports